import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import {
    clearAutomobileConvictions,
  fetchAutomobileDriverConvitionsListAsync,
} from "../../../../../../redux/automobileDriver/automobileDriverActions";

export const useAutomobilePolicyDriverConviction = (customerPolicyId?: number) => {
  const dispatch = useDispatchWrapper();
  const DriverConviction = useSelector(
    (storeState: IStoreState) =>
      storeState.automobile.driver.driverConviction.driverConvictionList
  );

  const driverConvictionDropDown = React.useMemo(() => {
    return DriverConviction.map((item) => {
      return {
        label: `${item.incremental_number || "--"} (Code: ${
          item.conviction_code || "N/A"
        } )`,
        value: item.incremental_number || "",
      };
    });
  }, [DriverConviction]);

  const refreshData = () => {
    if (customerPolicyId) {
      dispatch(fetchAutomobileDriverConvitionsListAsync(Number(customerPolicyId)));
    }
  }

  React.useEffect(() => {
    if (customerPolicyId) {
      dispatch(fetchAutomobileDriverConvitionsListAsync(Number(customerPolicyId)));
    }
    return () => {
      dispatch(clearAutomobileConvictions());
    };
  }, [customerPolicyId]);

  return { driverConvictionDropDown, refreshData };
};
